<template>
  <v-container
    id="catalog"
    tag="section"
  >
      <catalog-edit :moduleid="$route.params.id" />
  </v-container>
</template>

<script>
  import catalogEdit from '../components/CatalogEdit.vue'

  export default {
    name: 'CatalogEditPage',

    components: {
      'catalog-edit': catalogEdit,
    },

    data: () => ({
      loading: true,
    }),

    computed: {
      
    },

    async mounted () {
      this.loading = true
      this.loading = false
    },

    methods: {
    },

  }

</script>
